import React from 'react';
import { Label } from 'semantic-ui-react';
import isEmail from 'validator/es/lib/isEmail';
import { splitUrl } from '@/constants/urls';

const LinksLabels = ({ items }) => (
  items.map((i) => (
    <Label
      key={i}
      basic
      as="a"
      className="button-link"
      href={isEmail(i) ? `mailto:${i}` : i}
      content={isEmail(i) ? i : splitUrl(i).link}
      rel="noopener noreferrer"
      target="_blank"
    />
  ))
);

export default LinksLabels;
